import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import CircleColor from "Components/CircleColor/CircleColor";
import { useTranslation } from 'react-i18next';
import { useTheme } from "@material-ui/core";

export default function MuiColorAutoComplete({
  options,
  label,
  placeholder,
  className = "",
  loading,
  helperText,
  ...props
}) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const optionsWithColor = (option) => {
    return (
      <div className="color-auto-complete">
        {option.label}
        {
          <CircleColor
            background={option.Value}
            size="medium"
          />
        }
      </div>
    );
  };

  return (
    <div>
      <Autocomplete
        noOptionsText={<p style={{ color: "gray", textAlign: "right" }}>{t('Nothing_found')}</p>}
        {...props}
        disableClearable
        // disablePortal
        className={className}
        options={options}
        size={"small"}
        loadingText={t('pleaseWait')}
        ListboxProps={{ style: { maxHeight: 250, direction: direction } }}
        getOptionLabel={(option) => option?.label ?? ""}
        renderOption={(option) => optionsWithColor(option)}
        renderInput={(params) => (
          <TextField
            {...params}
            error={helperText ? true : false}
            InputLabelProps={{ shrink: true }}
            label={label}
            placeholder={placeholder}
            variant="outlined"
            helperText={helperText && t('selectOneItem')}
            type="search"
          />
        )}
      />
    </div>
  );
}
